(function () {
  /**
   * @ngdoc module
   * @name akitabox.workOrder.myList
   */
  angular
    .module("akitabox.workOrder.myList")
    .controller("MyWorkOrderListController", MyWorkOrderListController);

  /**
   * @ngdoc controller
   * @module akitabox.workOrder.myList
   * @description
   *
   */
  function MyWorkOrderListController(
    // Angular
    $location,
    $scope,
    $state,
    // Third Party
    // Services
    WorkOrderService,
    FeatureFlagService,
    IdentityService,
    OrganizationService,
    UserService,
    // Resolve
    query,
    status
  ) {
    var self = this;

    var filter = WorkOrderService.getMyListFilter() || {};

    // General query parameters
    var baseQuery = {
      open: {
        status: "open",
      },
      scheduled: {
        status: "scheduled",
      },
      closed: {
        status: "$in,completed,canceled",
      },
    };

    // Attributes
    self.activeTab = ["open", "scheduled", "closed"].indexOf(status);
    self.workOrders = {};
    self.searchText = null;
    self.organization = OrganizationService.getCurrent();
    self.user = UserService.getCurrent();

    // Functions
    self.getStatusClass = getStatusClass;
    self.onSelectTab = onSelectTab;
    self.selectWorkOrder = selectWorkOrder;
    self.hasLoadedOpen = hasLoadedOpen;
    self.hasLoadedClosed = hasLoadedClosed;
    self.hasLoadedScheduled = hasLoadedScheduled;
    self.emptyOpenList = emptyOpenList;
    self.emptyClosedList = emptyClosedList;
    self.addServiceRequest = addServiceRequest;
    self.addWorkOrder = addWorkOrder;
    self.emptyScheduledList = emptyScheduledList;

    init();

    /**
     * Initialize controller, request work orders
     */
    function init() {
      self.searchText = query ? query : filter.q;
      filter = angular.extend(
        {},
        { assignee_users: "$in," + self.user._id },
        filter
      );
      delete filter.assignee_account;

      fetchWorkOrders(self.searchText);
      self.searchOpen = !angular.isEmpty(self.searchText);

      // Watch search text
      $scope.$watch("vm.searchText", angular.debounce(onSearchTextChange, 500));
    }

    function onSearchTextChange(newValue, oldValue) {
      if (newValue !== oldValue) fetchWorkOrders(newValue);
    }

    function updateFilter(params) {
      filter = angular.extend(filter, params);
      WorkOrderService.setMyListFilter(filter);
    }

    function fetchWorkOrders(text) {
      $location.search("q", text);
      updateFilter({ q: text });
      var openParams = angular.extend({}, baseQuery.open, filter);
      var scheduledParams = angular.extend({}, baseQuery.scheduled, filter);
      var closedParams = angular.extend({}, baseQuery.closed, filter);
      var queryParams =
        "_number=" +
        filter.q +
        ";subject=" +
        filter.q +
        ";description_text=" +
        filter.q;

      if (filter.q) {
        openParams.$or = queryParams;
        scheduledParams.$or = queryParams;
        closedParams.$or = queryParams;
        delete openParams.q;
        delete scheduledParams.q;
        delete closedParams.q;
      }

      self.workOrders.open = WorkOrderService.getMyWorkOrderVirtualRepeat(
        10,
        openParams,
        self.organization._id
      );
      self.workOrders.scheduled = WorkOrderService.getMyWorkOrderVirtualRepeat(
        10,
        scheduledParams,
        self.organization._id
      );
      self.workOrders.closed = WorkOrderService.getMyWorkOrderVirtualRepeat(
        10,
        closedParams,
        self.organization._id
      );
    }

    function addServiceRequest() {
      $state.go("app.serviceRequests.create");
    }

    function addWorkOrder() {
      $state.go("app.workOrders.create");
    }

    /**
     * Retrieve class for work order status (warn, success, etc.)
     *
     * @param  {Object} workOrder   Work order
     * @return {String}             Class name
     */
    function getStatusClass(workOrder) {
      var status = workOrder ? workOrder.status_display : null;

      switch (status) {
        case "Overdue":
          return "fg-warn";
        case "Open":
          return "fg-success";
        case "Completed":
          return "fg-dark";
        default:
          return "fg-black";
      }
    }

    /**
     * Handle tab selection, update URL status query
     *
     * @param {String} tab Tab name (open, closed)
     */
    function onSelectTab(tab) {
      $location.search("status", tab);
    }

    /**
     * Navigate to work order details
     *
     * @param {Object} workOrder    The selected work order
     */
    function selectWorkOrder(workOrder) {
      $state.go("app.building.workOrder.detail", {
        buildingId: workOrder.building._id || workOrder.building,
        workOrderId: workOrder._id,
      });
    }

    function hasLoadedOpen() {
      if (self.workOrders.open) {
        return angular.isNumber(self.workOrders.open.numItems);
      }
      return false;
    }

    function hasLoadedClosed() {
      if (self.workOrders.closed) {
        return angular.isNumber(self.workOrders.closed.numItems);
      }
      return false;
    }

    function hasLoadedScheduled() {
      if (self.workOrders.scheduled) {
        return angular.isNumber(self.workOrders.scheduled.numItems);
      }
      return false;
    }

    function emptyOpenList() {
      if (self.workOrders.open) {
        return (
          self.workOrders.open.getLength() === 0 &&
          !self.workOrders.open.moreToLoad &&
          !self.workOrders.open.fetching
        );
      }
      return false;
    }

    function emptyScheduledList() {
      if (self.workOrders.scheduled) {
        return (
          self.workOrders.scheduled.getLength() === 0 &&
          !self.workOrders.scheduled.moreToLoad &&
          !self.workOrders.scheduled.fetching
        );
      }
      return false;
    }

    function emptyClosedList() {
      if (self.workOrders.closed) {
        return (
          self.workOrders.closed.getLength() === 0 &&
          !self.workOrders.closed.moreToLoad &&
          !self.workOrders.closed.fetching
        );
      }
      return false;
    }
  }
})();
